import { uuid } from "vue-uuid";

export function generateUUID(): string {
  return uuid.v4();
}
